import Vue from "vue";
import VueCookie from "vue-cookie";
import Vuex from "vuex";
import action from "./action";
import mutations from "./mutations";
import { getStore, tokenKey } from "/utils/storage";

Vue.use(VueCookie);
Vue.use(Vuex);

const state = {
  stationId: 7,
  stationName: "Renogy US",
  timezone: -7,
  countryId: 233,
  resourceDomain: process.env.RESOURCE_DOMAIN,
  login: !!getStore(tokenKey),
  userInfo: {
    userEmail: null,
    userImage: null,
    userNickname: null,
  },
  userBonusPoints: null,
  navList: [],
  commonSensor: {
    platform_type: "redeem",
    vip_level: "",
    country_station: "Renogy US",
  },
};

export default new Vuex.Store({
  state,
  action,
  mutations,
});



// WEBPACK FOOTER //
// ./src/store/index.js